import React from "react";

const DeleteToneOfVoice = () => {
  return (
    <div className="delete-tov-container">
      <div className="tov-title">Delete Tone of Voice</div>

      <label className="instruction-info">
        Are you sure you want to delete this Tone of Voice?
      </label>
    </div>
  );
};

export default DeleteToneOfVoice;
